import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["link"]

  connect() {
    this.observer = new IntersectionObserver(
      (entries) => this.onIntersect(entries),
      {
        rootMargin: "-20% 0px -80% 0px"
      }
    )

    // Observe all sections that nav links point to
    this.linkTargets.forEach(link => {
      const href = link.getAttribute("href")
      if (href && href.startsWith("#")) {
        const sectionId = href.substring(1)
        const section = document.getElementById(sectionId)
        if (section) {
          this.observer.observe(section)
        }
      }
    })
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  onIntersect(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const activeId = entry.target.id
        this.setActiveLink(activeId)
      }
    })
  }

  setActiveLink(activeId) {
    this.linkTargets.forEach(link => {
      const href = link.getAttribute("href")
      const isActive = href === `#${activeId}`
      const isMobile = link.classList.contains("block")

      if (href && href.startsWith("#")) {
        if (isActive) {
          link.classList.add("text-slate-900", "font-semibold")
          link.classList.remove("text-slate-600", "text-slate-700", "font-medium")
          // Only add underline on desktop
          if (!isMobile) {
            link.classList.add("border-b-2", "border-slate-900")
          }
        } else {
          link.classList.remove("text-slate-900", "font-semibold", "border-b-2", "border-slate-900")
          if (isMobile) {
            link.classList.add("text-slate-700", "font-medium")
          } else {
            link.classList.add("text-slate-600", "font-medium")
          }
        }
      }
    })
  }
}
